// setup-default-tools-on-init.ts
//
// Bước init: BẬT TẤT CẢ tool có trong pack — KHÔNG hỏi từng cái.
//
// Lý do (user chốt 2026-06-13): đã có `avatar tools list/enable/disable` để user
// gỡ bất kỳ lúc nào → hỏi từng tool lúc init là thừa. Cài tất cả là mặc định.
//
// - Nguồn tool = quét pack/tools/*/tool.json (listAvailableTools), KHÔNG phải
//   danh sách cứng trong defaults.json. Thêm tool mới vào pack → tự bật.
// - ai-orchestrator xử lý RIÊNG (cần picker chọn model interactive sau AI setup
//   — xem maybe-prompt-ai-orchestrator-after-ai-setup.ts). Lọc khỏi vòng này.
// - Fail-mềm: pack chưa có tools/ → rỗng → no-op im lặng.

import { listAvailableTools } from "./discover-pack-tools-and-defaults.js";
import { log } from "./terminal-logger.js";
import { enableToolByName } from "./tool-enable-disable-orchestrator.js";

// Tool xử lý RIÊNG (không bật ở vòng default chung). ai-orchestrator cần biết số
// model key + chạy picker → bật sau AI setup, không bật mù ở đây.
// Export (#148): sync auto-enable-new-tools dùng CHUNG set này — 1 nguồn, không duplicate.
export const HANDLED_SEPARATELY = new Set(["ai-orchestrator"]);

export async function setupDefaultToolsOnInit(
  workspacePath: string,
  // opts giữ để tương thích caller (autoYes không còn ảnh hưởng — luôn bật).
  _opts: { autoYes?: boolean } = {},
): Promise<void> {
  const available = await listAvailableTools(workspacePath);
  const toEnable = available.filter((name) => !HANDLED_SEPARATELY.has(name));
  if (toEnable.length === 0) {
    return; // pack chưa có tools/ (hoặc chỉ còn tool xử lý riêng) → no-op.
  }

  log.info(`Bật ${toEnable.length} tool mặc định (gỡ sau bằng 'avatar tools disable <tên>')...`);
  for (const name of toEnable) {
    // silent: tool có thể thiếu trong pack cũ → không spam warning.
    await enableToolByName(workspacePath, name, { silent: true });
    log.dim(`  ✓ ${name}`);
  }
}
